import React, { Suspense } from "react";
import { Box, Card, Skeleton, Stack } from "@mui/material";

const DeviceTypeCard = React.lazy(() => import("../../Cards/DeviceTypeCard"));

function DeviceTypeSkeleton() {
  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, minmax(0, 1fr))",
          lg: "repeat(3, minmax(0, 1fr))",
        },
        gap: 2,
        px: { xs: 2, md: 3 },
      }}
    >
      {Array.from({ length: 6 }).map((_, index) => (
        <Card
          key={index}
          sx={{
            p: 2.5,
            borderRadius: 4,
            border: "1px solid rgba(148, 163, 184, 0.18)",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(248,250,252,0.98))",
            boxShadow: "0 20px 50px rgba(15, 23, 42, 0.08)",
          }}
        >
          <Stack spacing={2}>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="72%" height={32} />
                <Skeleton variant="text" width="48%" height={22} />
              </Box>
              <Skeleton
                variant="rounded"
                width={52}
                height={52}
                sx={{ borderRadius: 3 }}
              />
            </Stack>

            <Skeleton variant="rounded" width="100%" height={78} sx={{ borderRadius: 3 }} />

            <Stack direction="row" spacing={1}>
              <Skeleton
                variant="rounded"
                width={92}
                height={30}
                sx={{ borderRadius: 999 }}
              />
              <Skeleton
                variant="rounded"
                width={112}
                height={30}
                sx={{ borderRadius: 999 }}
              />
            </Stack>
          </Stack>
        </Card>
      ))}
    </Box>
  );
}

function DeviceType() {
  return (
    <Box
      sx={{
        minHeight: "100%",
        pt: { xs: 5, sm: 5, md: 1 },
        pb: 4,
        background:
          "radial-gradient(circle at top left, rgba(14, 165, 233, 0.14), transparent 30%), radial-gradient(circle at top right, rgba(16, 185, 129, 0.12), transparent 28%), linear-gradient(180deg, #f8fbff 0%, #eef4f8 100%)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          mb: 3,
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
        }}
      >
        <Suspense fallback={<DeviceTypeSkeleton />}>
          <DeviceTypeCard />
        </Suspense>
      </Box>
    </Box>
  );
}

export default DeviceType;
